import React from "react";
import InkAppCta from "../product/InkAppCta";

export default function HomeAppCtas({ className = "", align = "start" }) {
  return (
    <div
      className={[
        "flex flex-wrap items-center gap-x-5 gap-y-3",
        align === "center" ? "justify-center" : "justify-start",
        className,
      ].join(" ")}
    >
      <InkAppCta>Get Stratify for iPhone</InkAppCta>
    </div>
  );
}
